var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEyeLined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 8.52414C9.185 8.52414 8.52431 9.18483 8.52431 9.99984C8.52431 10.8148 9.185 11.4755 10 11.4755C10.815 11.4755 11.4757 10.8148 11.4757 9.99984C11.4757 9.18483 10.815 8.52414 10 8.52414ZM7.58681 9.99984C7.58681 8.66707 8.66723 7.58664 10 7.58664C11.3328 7.58664 12.4132 8.66707 12.4132 9.99984C12.4132 11.3326 11.3328 12.413 10 12.413C8.66723 12.413 7.58681 11.3326 7.58681 9.99984Z",
    fill: "#0C0C0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.82855 10.0307C2.70342 11.3464 3.8782 12.6426 5.23353 13.6278C6.68625 14.6838 8.32011 15.3644 10 15.3644C11.6799 15.3644 13.3138 14.6838 14.7665 13.6278C16.1218 12.6426 17.2966 11.3464 18.1715 10.0307C15.9661 7.32061 13.5252 4.63525 10 4.63525C6.47478 4.63525 4.03398 7.32065 1.82855 10.0307ZM0.885548 9.70505C3.09278 6.97619 5.84563 3.69775 10 3.69775C14.1544 3.69775 16.9073 6.97615 19.1145 9.70506C19.2407 9.86116 19.2535 10.0803 19.1464 10.2501C18.201 11.7473 16.8782 13.2518 15.3177 14.3861C13.7582 15.5198 11.9351 16.3019 10 16.3019C8.06489 16.3019 6.24179 15.5198 4.68229 14.3861C3.12186 13.2518 1.79899 11.7473 0.853651 10.2501C0.746457 10.0803 0.759284 9.86115 0.885548 9.70505Z",
    fill: "#0C0C0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEyeLined);
export default __webpack_public_path__ + "static/media/ic_eye_lined.89e9bdb00a42df39001e2d7c0e602171.svg";
export { ForwardRef as ReactComponent };